import React from 'react';
const testimonials = [{
  initials: 'LG',
  name: 'Laura G.',
  location: 'Buenos Aires · Mamá Primeriza',
  quote: 'Llegué al parto sabiendo exactamente qué decirle al médico, con mi plan de parto impreso en 3 copias y con el bolso listo desde la semana 36. No hubo ninguna sorpresa. Solo fui a tener a mi bebé.'
}, {
  initials: 'VR',
  name: 'Valeria R.',
  location: 'Córdoba · Mamá Primeriza',
  quote: 'El Tomo de Compras me ahorró una fortuna. Iba a gastar en cosas que después entendí que eran innecesarias. El sistema de las 3 categorías cambió completamente cómo preparé la llegada de Emilio.'
}, {
  initials: 'MP',
  name: 'Martina P.',
  location: 'Rosario · Mamá Primeriza',
  quote: 'El Planificador de Turnos fue lo primero que imprimí y pegué en la heladera. Llegaba a cada consulta con las preguntas anotadas y los resultados ordenados. Mi obstetra me preguntó qué sistema usaba.'
}];
const painPoints = ['Abrís Instagram y ves fotos de embarazadas radiantes mientras vos tenés náuseas, miedo y mil preguntas sin respuesta', 'Googleaste síntomas y terminaste convencida de que algo está mal cuando en realidad es completamente normal', 'Alguien te dijo "disfrutalo" cuando lo único que sentís es ansiedad por no saber qué sigue', 'Tenés mil papeles de estudios, órdenes y resultados que no sabés cómo organizar ni para qué sirven', 'Sabés "algo" de cada cosa pero no tenés un sistema claro que te diga qué hacer en cada etapa', 'Compraste ropa de bebé en talle RN sin saber que quizás tu bebé ni lo va a usar dos semanas', 'No sabés cuáles son tus derechos el día del parto ni cómo hacer un plan de parto que te respeten', 'Escuchaste historias de partos que te llenaron de miedo sin nadie que te diga la verdad real', 'Fin de semana consumiendo contenido gratis en TikTok y el lunes volvés a empezar el mismo ciclo de ansiedad'];
export function ProblemSection() {
  return <section className="py-16 md:py-24" data-id="element-122">
      <div className="max-w-6xl mx-auto px-4" data-id="element-123">
        {/* Testimonials */}
        <div className="grid md:grid-cols-3 gap-5 md:gap-6 mb-20 md:mb-28" data-id="element-124">
          {testimonials.map((t, i) => <div key={i} className="bg-white shadow-lg border border-pink-200 rounded-2xl p-6 hover:border-fuchsia-300 transition-colors" data-id="element-125">
              <div className="flex items-center gap-3 mb-4" data-id="element-126">
                <div className="w-11 h-11 rounded-full bg-fuchsia-50 text-fuchsia-600 flex items-center justify-center font-bold text-sm border border-fuchsia-200" data-id="element-127">
                  {t.initials}
                </div>
                <div data-id="element-128">
                  <div className="text-fuchsia-500 text-xs tracking-wider mb-0.5" data-id="element-129">
                    ★★★★★
                  </div>
                  <div className="text-sm text-gray-800 font-medium" data-id="element-130">
                    {t.name}
                  </div>
                </div>
              </div>
              <p className="text-gray-700 italic leading-relaxed text-sm md:text-base" data-id="element-131">
                "{t.quote}"
              </p>
              <div className="mt-4 text-xs text-gray-500 font-medium" data-id="element-132">
                {t.location}
              </div>
            </div>)}
        </div>

        {/* Pain Points */}
        <div className="max-w-3xl mx-auto text-center mb-10 md:mb-12" data-id="element-133">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-134">
            ¿Cuántos domingos más vas a buscar información en Google que te
            genera más miedo que respuestas?
          </h2>
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed" data-id="element-135">
            Querés prepararte para el embarazo y la llegada de tu bebé. Tenés
            las ganas. Pero nadie te dijo que ibas a pasar las noches leyendo
            artículos contradictorios, los domingos en grupos de Facebook llenos
            de opiniones que se cancelan entre sí y los lunes con más preguntas
            que respuestas.
          </p>
          <p className="text-lg md:text-xl text-fuchsia-600 font-semibold mt-6" data-id="element-136">
            No es falta de capacidad. Es falta de un sistema.
          </p>
        </div>

        <div className="max-w-3xl mx-auto bg-white/80 backdrop-blur-sm shadow-xl border border-pink-200 rounded-2xl md:rounded-3xl p-6 md:p-10" data-id="element-137">
          <div className="space-y-5" data-id="element-138">
            {painPoints.map((point, i) => <div key={i} className="flex items-start gap-3 md:gap-4" data-id="element-139">
                <span className="text-red-500 text-lg mt-0.5 shrink-0" data-id="element-140">❌</span>
                <p className="text-base md:text-lg text-gray-800" data-id="element-141">{point}</p>
              </div>)}
          </div>
        </div>

        <div className="text-center mt-12 md:mt-16" data-id="element-142">
          <h3 className="text-2xl md:text-4xl font-bold text-gray-900" data-id="element-143">
            ¿Y si este fuera el último domingo que empezás sin un sistema?
          </h3>
        </div>
      </div>
    </section>;
}